<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="PN expiry date:" prop="pnExpiryDate">
        <el-date-picker
          valueFormat="yyyy-MM-dd"
          format="yyyy-MM-dd"
          style="width: 300px"
          v-model="form.pnExpiryDate"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    return {
      formName: 'PN',
      form: {
        pnExpiryDate: '',
      },
      commonFormData: {},
      rules: {
        pnExpiryDate: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(this.form, 'pnExpiryDate', newValue.pnExpiryDate)
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
